import * as React from "react";
import { useId } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHeart1 = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		viewBox: "0 0 20 20",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: /* @__PURE__ */ _jsx("path", {
			d: "M13.3252 2.75C14.4638 2.75004 15.3792 3.13258 16.124 3.89648C16.87 4.66173 17.25 5.61071 17.25 6.7959C17.25 7.38042 17.1539 7.95185 16.9609 8.51367C16.7728 9.06142 16.4299 9.6964 15.9053 10.4209C15.381 11.1448 14.6634 11.978 13.7441 12.9209C12.8216 13.8673 11.6491 14.9979 10.2246 16.3145L9.5 16.9805L8.77539 16.3145C7.3509 14.9979 6.17841 13.8673 5.25586 12.9209C4.33664 11.978 3.61899 11.1448 3.09473 10.4209C2.5701 9.6964 2.22716 9.06142 2.03906 8.51367C1.84614 7.95185 1.75003 7.38042 1.75 6.7959C1.75 5.61071 2.12998 4.66173 2.87598 3.89648C3.62079 3.13258 4.53618 2.75004 5.6748 2.75C6.29872 2.75 6.88935 2.88413 7.4541 3.15527C8.02019 3.42709 8.50866 3.80971 8.92285 4.30957C9.06534 4.48143 9.27675 4.58105 9.5 4.58105C9.72325 4.58105 9.93466 4.48143 10.0771 4.30957C10.4913 3.80971 10.9798 3.42709 11.5459 3.15527C12.1107 2.88413 12.7013 2.75 13.3252 2.75Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		})
	});
};
export default SvgHeart1;
